import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Tag, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { EditInfo, DeleteModal } from ".";
import { getSubscriptionsList, patchSubscriptionStatus } from "../../appRedux/actions/subscriptions";

function ListView() {
  const dispatch = useDispatch();
  const subscriptionList = useSelector((state) => state.subscriptions.subscriptionList);
  const queryInfo = useSelector((state) => state.subscriptions.queryInfo);
  const totalRecords = useSelector((state) => state.subscriptions.totalRecords);

  useEffect(() => {
    dispatch(getSubscriptionsList(queryInfo)).catch(() => {});
  }, []);

  const handleTableChange = (pagination) => {
    const page = pagination?.current || 1;
    const size = pagination?.pageSize || queryInfo.size;
    dispatch(getSubscriptionsList({ ...queryInfo, page, size })).catch(() => {});
  };

  const columns = [
    {
      title: "Subscription & Details",
      dataIndex: "title",
      key: "title",
      align: "left",
      render: (title, record) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ fontWeight: 600, fontSize: "14px", color: "#333" }}>{title || "—"}</span>
          {record.description && (
            <span style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
              {record.description.length > 50 ? `${record.description.substring(0, 50)}...` : record.description}
            </span>
          )}
        </div>
      ),
    },
    {
      title: "Merchant",
      dataIndex: "merchant",
      key: "merchant",
      align: "center",
      render: (merchant) => (
        <Tag color="cyan" style={{ borderRadius: '4px', color: '#006d75', borderColor: '#87e8de', background: '#e6fffb' }}>
          <i className="fa fa-building-o mr-1" /> {merchant || "—"}
        </Tag>
      ),
    },
    {
      title: "Tiers & Pricing",
      dataIndex: "tiers",
      key: "tiers",
      align: "center",
      render: (tiers) => {
        if (!tiers || tiers.length === 0) return <span style={{ color: "#aaa" }}>No tiers defined</span>;
        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", justifyContent: "center" }}>
            {tiers.map((tier, idx) => (
              <Tooltip
                key={idx}
                title={
                  <div>
                    <strong>Cycle:</strong> {tier.billingCycle} {tier.customCycleDays ? `(${tier.customCycleDays} days)` : ""}
                    <br />
                    <strong>Features:</strong> {tier.features || "None"}
                  </div>
                }
              >
                <Tag color={tier.isActive ? "blue" : "default"} style={{ borderRadius: "4px" }}>
                  {tier.name}: <strong>{tier.price} {tier.currency || "INR"}</strong>
                </Tag>
              </Tooltip>
            ))}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => {
        const color =
          status === "ACTIVE" ? "success" : status === "DRAFT" ? "default" : "error";
        return <Tag color={color} style={{ borderRadius: '4px' }}>{status}</Tag>;
      },
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      width: 80,
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div className="dropdown dropdown-action text-center" style={{ padding: "8px" }}>
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <EditInfo info={record} key={record._id} />
            {record.status === "ACTIVE" ? (
              <button
                className="dropdown-item"
                onClick={() =>
                  dispatch(
                    patchSubscriptionStatus(record._id, "INACTIVE")
                  )
                    .then(() => {
                      dispatch(getSubscriptionsList(queryInfo)).catch(() => {});
                    })
                    .catch(() => {})
                }
              >
                <i className="fa fa-pause m-r-5" /> Deactivate
              </button>
            ) : (
              <button
                className="dropdown-item"
                onClick={() =>
                  dispatch(
                    patchSubscriptionStatus(record._id, "ACTIVE")
                  )
                    .then(() => {
                      dispatch(getSubscriptionsList(queryInfo)).catch(() => {});
                    })
                    .catch(() => {})
                }
              >
                <i className="fa fa-play m-r-5" /> Activate
              </button>
            )}
            <DeleteModal info={record} />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive">
      <Table
        className="platform-hub-table"
        rowKey="_id"
        columns={columns}
        dataSource={subscriptionList}
        pagination={{
          current: queryInfo?.page || 1,
          pageSize: queryInfo?.size || 10,
          total: totalRecords,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20", "50"],
          showTotal: (total) => `Total ${total} subscriptions`,
        }}
        onChange={handleTableChange}
      />
    </div>
  );
}

export default ListView;
